import { hc_ds } from './_datastore.js';
import { hc_utils } from './_utils.js';
import { hc_templates } from './_templates.js';

export let hc_payment = {};

/*
----------------------------
Summaries and Payments - Templates
----------------------------
*/
hc_payment.summary = function(paymentSummary){
    hc_utils.loader(paymentSummary, true);

    let storage = hc_utils.getSessionStorage(hccosp.vars.session);
    if(storage){
        
        let settings = {
            "conf": storage
        }
        hc_ds.fn.getData(settings).then(function(dsResponse){
            hccosp.data.ds_data = dsResponse;
            
            let options = paymentSummary.dataset;
            hccosp.vars.proxy = options.proxy || "";
            let dom = hc_templates[storage.collection](dsResponse, storage.type);
            hc_utils.loader(paymentSummary, false);
            paymentSummary.innerHTML = dom;

            // if the user has not paid
            if(dsResponse.progressStatusId != 36){
                // set status
                hc_payment.updateStatus(9);
                // if there is a form in play
                let hasForm = hc_utils.hasSummaryForm(storage.collection);
                if(hasForm){
                    let theForm = paymentSummary.querySelector('#ds_details_form');

                    // get all fields with existing data
                    const existingData = {},
                        changedFields = [],
                        changedFieldsInput = document.querySelector("#changed-fields");

                    theForm.querySelectorAll(`[name]`).forEach(field => existingData[field.name] = field.value);

                    // add form change handler to store when the form has had a change of value
                    theForm.addEventListener('change', function({ target }) {
                        const hasIndex = changedFields.indexOf(target.name) !== -1,
                            index = changedFields.indexOf(target.name);

                        let formData = new FormData(theForm);
                        let formHash = hc_utils.hashForm(formData);

                        if(formHash != hc_utils.vars.formHash){
                            hc_utils.vars.formHasChanged = true;
                        } else {
                            hc_utils.vars.formHasChanged = false;
                        }

                        if (existingData[ target.name ] !== target.value && !hasIndex) {
                            changedFields.push(target.name);
                        }
                        else if (existingData[ target.name ] === target.value && hasIndex) {
                            delete changedFields[index];
                        }

                        if (changedFieldsInput) {
                            changedFieldsInput.value = changedFields.filter(Boolean).join(",");
                        }
                    });

                    // set a baseline value to compare to later
                    hc_utils.vars.formHash = hc_utils.hashForm(new FormData(theForm));
                }

                // get windcave session
                // 
                let windcaveSessionUrl = `${options.wcsession}?pageid=${options.pageid}&dsId=${hccosp.data.ds_data.dsId}&dsCollection=${options.collection}&identifier=${hccosp.data.ds_data.id}`;

                fetch(windcaveSessionUrl).then((wc_response) => wc_response.json())
                .then(function(wc_data){
                    hccosp.data['wc_data'] = wc_data;
                    hc_payment.updateStatus(18);

                    hc_payment.insertSessionButtons(paymentSummary);
                    paymentSummary.querySelector('form').addEventListener('submit', function(e){
                        e.preventDefault();
                    });
                });
                
            } else {
                //console.log('payment already made!');
            }

        });
        
    } else {
        hc_utils.loader(paymentSummary, false);
        hc_utils.notifier(hc_templates.notifiers.general.record_error);
    }
};

hc_payment.insertSessionButtons = function(paymentSummary){

    // Show THE Pay now buttons

    // generate dom node
    let newFormControl = document.createElement("div");
    newFormControl.classList.add('sq-form-control','animate__fadeIn');

    // Windcave
    // get the links object with a rel = 'hpp' value
    // We need this to redirect to the WC HPP
    hccosp.data.wc_data.links.forEach(function(link){
        if(link.rel == 'hpp'){
            // generate Pay now submit button
            let wcButton = document.createElement("button");
            wcButton.type = 'button';
            wcButton.setAttribute('id', 'hc_wc_pay');
            wcButton.classList.add('mr-3');
            //wcButton.classList.add('hc_wc_pay');
            wcButton.dataset.type = 'windcave';
            wcButton.dataset.target = link.href;
            const wcContent = document.createTextNode("Continue with Credit Card");
            wcButton.appendChild(wcContent);
            newFormControl.appendChild(wcButton);
        }
    });
;
    // display buttons
    paymentSummary.querySelector('form').appendChild(newFormControl);

    document.getElementById('hc_wc_pay').addEventListener('click', hc_payment.submitToPayment);
}
// handler for WINDCAVE redirection
hc_payment.submitToPayment = function(e){
    let storage = hc_utils.getSessionStorage(hccosp.vars.session);
    // set status
    // assume windcave, set some values
    const target = e.target.dataset.target;
    let dataSet = hccosp.data.wc_data;
    let paymentType = 'windcave';
    let statusCode = 27;

    let timestamp = hc_utils.getTimestamp();
    let currentRecord = [{"id": dataSet.id, "timestamp": timestamp}];
    let history = hc_payment.generateHistory(currentRecord, hccosp.data.ds_data.paymentReceiptHistory);

    /*let paymentReceiptHistory = [{"id": dataSet.id, "timestamp": timestamp}];
    if(hccosp.data.ds_data.paymentReceiptHistory && hccosp.data.ds_data.paymentReceiptHistory.length > 0){
        paymentReceiptHistory = JSON.parse(hccosp.data.ds_data.paymentReceiptHistory)
        paymentReceiptHistory.push({"id": dataSet.id, "timestamp": timestamp});
    }*/

    var settings = {
        "paymentReceipt": dataSet.id,
        "paymentReceiptHistory": JSON.stringify(history),
        "paymentType": paymentType
    }

    //hc_payment.updateStatus(statusCode, settings);

    let paymentSummary = document.querySelector('.hccosp-payment-summary');
    let renewOption = paymentSummary.querySelector('#opt_renewal');
    let renewOptionIsChecked = true;
    if(renewOption){
        renewOptionIsChecked = renewOption.checked;
    }
    // if "renew only" is chosen, only submit the form changes.
    // eg dont follow to the pay now screen.

    // if there is an editable summary form
    let hasForm = hc_utils.hasSummaryForm(storage.collection);
    if(hasForm){
        let theForm = paymentSummary.querySelector('#ds_details_form');
        let formIsValid = theForm.checkValidity();

        if(!formIsValid){
            // return user to form
            theForm.reportValidity();
            return false;
        }
        // send updated details to hcc when the form has changed
        // or the renew option is not checked
        if(hc_utils.vars.formHasChanged){
            // submit form...
            let formEndpoint = theForm.action;
            let formData = new FormData(theForm);
            formData.append('dsId', storage.dsId);
            formData.append('collection', storage.collection);

            fetch(formEndpoint, {
                method: "POST",
                body: formData
            }).then((formResponse) => formResponse.json()).then(res => {
                //then redirect
                if(renewOptionIsChecked){
                    // head to payment
                    let thisCallback = function(){
                        window.location = target;
                    };
                    // set status
                    hc_payment.updateStatus(statusCode, settings, thisCallback);
                } else {
                    // notify user of action completed.
                    hc_utils.notifier(hc_templates.notifiers.general.updated_details_success);
                }
            });
        } else {
            // no changes to form. head to payment
            // no edit form. head to payment
            let thisCallback = function(){
                window.location = target;
            };
            // set status
            hc_payment.updateStatus(statusCode, settings, thisCallback);
        }
    } else {
        // no edit form. head to payment
        let thisCallback = function(){
            window.location = target;
        };
        // set status
        hc_payment.updateStatus(statusCode, settings, thisCallback);
        
    }

};

// 
// see hc_ds.status for values
hc_payment.updateStatus = function(statusId, incSettings, callback){
    let storage = hc_utils.getSessionStorage(hccosp.vars.session);
    if(storage){
        let statusDescription = hc_ds.status[statusId] || "Incorrect status ID";
        
        let settings = {
            "conf": storage,
            "data": {
                "progressStatus": statusDescription,
                "progressStatusId": statusId
            }
        }
        if(incSettings){
            let paymentReceipt = incSettings.paymentReceipt || null;
            let paymentReceiptHistory = incSettings.paymentReceiptHistory || null;
            let paymentStatus = incSettings.paymentStatus || null;
            let paymentType = incSettings.paymentType || null;
            if(paymentReceipt){
                settings.data.paymentReceipt = paymentReceipt;
            }
            if(paymentReceiptHistory){
                settings.data.paymentReceiptHistory = paymentReceiptHistory;
            }
            if(paymentStatus){
                settings.data.paymentStatus = paymentStatus;
            }
            if(paymentType){
                settings.data.paymentType = paymentType;
            }
        }

        hc_ds.fn.setData(settings).then(function(setDataResponse){
            hccosp.data.ds_data = setDataResponse;
            if(callback){
                callback();
            }
        });
    }
    
}














hc_payment.generateHistory = function(newArr, strArr){
    let historyObj = newArr;

    if(strArr && strArr != "" && strArr.length > 0){
        historyObj = JSON.parse(strArr);
        historyObj.push(newArr[0]);
    }

    return historyObj;
};

hc_payment.success = function(element){
    //hc_utils.loader(element, true);
    let successResponse = element.querySelector('.hccosp-payment-success__response');
    if(element && successResponse){
        let dataset = successResponse.dataset;

        var settings = {
            "dsId": dataset.dsid,
            "collection": dataset.collection,
            "type": dataset.type,
            "paymentStatus": dataset.status
        }
        hc_utils.setSessionStorage(hccosp.vars.session, settings);
        hc_payment.updateStatus(36, settings);

    } else {
        hc_utils.notifier(hc_templates.notifiers.general.record_error);
    }
};

hc_payment.cancelled = function(element){
    //hc_utils.loader(element, true);

    let cancelledResponse = element.querySelector('.hccosp-payment-cancelled__response');
    if(element && cancelledResponse){
        let dataset = cancelledResponse.dataset;

        var settings = {
            "dsId": dataset.dsid,
            "collection": dataset.collection,
            "type": dataset.type,
            "paymentStatus": dataset.status
        }
        hc_utils.setSessionStorage(hccosp.vars.session, settings);
        hc_payment.updateStatus(38, settings);

    } else {
        hc_utils.notifier(hc_templates.notifiers.general.record_error);
    }
};

hc_payment.failed = function(element){
    //hc_utils.loader(element, true);

    let failedResponse = element.querySelector('.hccosp-payment-failed__response');
    if(element && failedResponse){
        let dataset = failedResponse.dataset;

        var settings = {
            "dsId": dataset.dsid,
            "collection": dataset.collection,
            "type": dataset.type,
            "paymentStatus": dataset.status
        }
        hc_utils.setSessionStorage(hccosp.vars.session, settings);
        hc_payment.updateStatus(40, settings);

    } else {
        hc_utils.notifier(hc_templates.notifiers.general.record_error);
    }
};
